"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Backdrop_1 = __importDefault(require("../../Backdrop"));
var CircularProgress_1 = __importDefault(require("../../CircularProgress"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Loader = function () {
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement(Backdrop_1.default, { open: true, classes: { root: classes.root } },
        react_1.default.createElement(CircularProgress_1.default, { color: "inherit" })));
};
exports.default = Loader;
